import {
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarMenuSub,
} from "@components/ui/sidebar";
import { ChevronRightIcon } from "lucide-react";
import { ROUTES } from "@/routes_new";
import { Trans } from "@lingui/react/macro";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@components/ui/collapsible";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { SearchLight } from "@/types/Search";
import { SearchItem } from "./SearchItem";

export function SavedSearches({
  savedSearches,
  orgUuid,
  pathname,
}: {
  savedSearches: SearchLight[];
  orgUuid: string;
  pathname: string;
}) {
  const [isOpen, setIsOpen] = useLocalStorage(
    "sidebar-saved-searches-open",
    false
  );

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={setIsOpen}
      className="group/saved-searches"
    >
      <SidebarMenuItem>
        <CollapsibleTrigger asChild>
          <SidebarMenuButton className="text-muted-foreground">
            <Trans>Sparade sökresultat</Trans>
            <ChevronRightIcon className="ml-auto transition-transform group-data-[state=open]/saved-searches:rotate-90" />
          </SidebarMenuButton>
        </CollapsibleTrigger>
      </SidebarMenuItem>

      <CollapsibleContent>
        <SidebarMenuSub>
          {savedSearches.map((search) => {
            const to = ROUTES.SAVED_SEARCHES_DETAIL_ORGID.replace(
              ":orgUuid",
              orgUuid
            ).replace(":uuid", search.uuid);

            return (
              <SearchItem
                key={search.uuid}
                to={to}
                isInSubMenu
                search={search}
                orgUuid={orgUuid}
                pathname={pathname}
              />
            );
          })}
        </SidebarMenuSub>
      </CollapsibleContent>
    </Collapsible>
  );
}
